<div class="flex flex-row flex-auto flex-grow-0 md:justify-center items-center">
    <button [matMenuTriggerFor]="userActions" class="user-button md:px-4 rounded" disableRipple mat-button>
        <div
            *ngIf="currentAccount$ | async as currentAccount"
            class="user-button flex flex-row justify-start items-center"
        >
            <mat-icon svgIcon="streamline-regular:single-neutral-circle"></mat-icon>
            <h5 class="username">{{ currentAccount.fullName }}</h5>
        </div>
    </button>

    <mat-menu class="user-menu" [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item *ngIf="currentAccount$ | async as currentAccount">
            <span class="flex flex-col leading-none">
                <span>{{ "features.dashboard.components.user_menu.signed_in_as" | translate }}</span>
                <span class="mt-1.5 text-md font-medium">{{ currentAccount.email }}</span>
            </span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item [matMenuTriggerFor]="changeLanguages">
            <mat-icon svgIcon="streamline-regular:translate"></mat-icon>
            <span>{{ ("general.languages." + currentLanguage) | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="(isDevelopment$ | async) || (isStaging$ | async)" (click)="clearCache()">
            <mat-icon svgIcon="streamline-regular:bin-1"/>
            <span>{{ "features.dashboard.components.user_menu.clear_cache" | translate }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ "features.dashboard.components.user_menu.sign_out" | translate }}</span>
        </button>
    </mat-menu>

    <mat-menu #changeLanguages="matMenu">
        <button mat-menu-item *ngFor="let language of availableLanguages" (click)="updateLanguage(language)">
            <span>{{ ("general.languages." + language) | translate }}</span>
        </button>
    </mat-menu>
</div>
